import { useQuery } from '@tanstack/react-query';

import { listFormulaEntries } from '../api/formula-library.api';
import { FORMULA_ENTRIES_QUERY_KEY } from '../constants/reports-query-keys';

export const useFormulaEntries = (reportType?: string) => {
  return useQuery({
    queryKey: [...FORMULA_ENTRIES_QUERY_KEY, reportType],
    queryFn: () => listFormulaEntries(reportType),
    staleTime: 10 * 60 * 1000,
  });
};
